/*
 * File: index.tsx
 * Project: meki
 * File Created: Monday, 24th May 2021 11:02:23 am
 * Author: Luis Aparicio (luis@inventures.cl)
 * -----
 * Last Modified: Tuesday, 19th October 2021 7:18:52 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */

import { SEOHead } from '@components/seo';
import { BasePage } from '@components/BaseHome';

export default function SuggestionsComplaiments() {
  return (
    <>
      <SEOHead title="Meki · Devoluciones" />
      <BasePage />
    </>
  );
}
